import React, { useEffect } from "react";
import { useLoaderData } from "react-router-dom";

import DocumentsList from "../../../../../components/modules/Documents/ViewDocuments/components/DocumentsList";
import Navigation from "../../../../../components/navigations/client/detail/documents/navigation";
import useParentLoaderData from "../../../../../hooks/useParentLoaderData";
import { NavigationHistoryService } from "../../../../../services/navigation-history-service";

export default () => {
  const { _case } = useParentLoaderData(2);
  const { documents, documentsCount } = useLoaderData();

  useEffect(() => {
    const navService = new NavigationHistoryService();
    navService.save("client-detail", "/documents/all-docs");
  }, []);

  return (
    <Navigation activeTab="all-docs" _case={_case}>
      <DocumentsList
        _case={_case}
        documents={documents}
        documentsCount={documentsCount}
        withPagination={true}
      />
    </Navigation>
  );
};
